// src/apiConfig.js import { LOGIN_URL } from '../apiConfig';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// const API_BASE_URL = 'https://milki.nilsmarketing.com';


// ENDPOINTS PARA GESTIÓN DE USUARIOS
export const LOGIN_URL = `${API_BASE_URL}/api/users/login/`;
export const LOGOUT_URL = `${API_BASE_URL}/api/users/logout/`;
export const REGISTER_URL = `${API_BASE_URL}/api/users/register/`;
export const CONFIGURATION_GLOBAL_URL = `${API_BASE_URL}/api/configuracion-global/`;

// ENDPOINTS PARA FUNCIONALIDAD DE APP ESTUDIANTES
export const SUMMARY_URL = `${API_BASE_URL}/api/tracking/summary/`;
export const RESUMEN_URL = `${API_BASE_URL}/api/tracking/resumen/`;
export const PROSPECTION_URL = `${API_BASE_URL}/api/tracking/prospection/`;
export const PERSONAL_URL = `${API_BASE_URL}/api/tracking/personal/`;
export const PROFILE_URL = `${API_BASE_URL}/api/tracking/profile/`;

export const PROSPECTS_URL = `${API_BASE_URL}/api/tracking/contactos/`;
export const CLIENTS_URL = `${API_BASE_URL}/api/tracking/clients/`;
export const CLIENT_LIST_CREATE_URL = `${API_BASE_URL}/api/tracking/clients/<int:pk>/`;
export const CLIENTS_STATS_URL = `${API_BASE_URL}/api/tracking/clients/stats/`;
export const IMPORT_CSV_URL = `${API_BASE_URL}/api/contactos/import-csv/`;

export const REMINDERS_URL = `${API_BASE_URL}/api/tracking/reminders/<int:pk>/`;
export const REMINDERS_TODAY_URL = `${API_BASE_URL}/api/tracking/reminders/today/`

//ENDPOINTS PARA SUPERVISORES
export const USERS_URL = `${API_BASE_URL}/api/users/`;
export const STUDENT_DATA_URL = `${API_BASE_URL}/api/tracking/student-data/`;
export const UPDATE_USER_URL = `${API_BASE_URL}/api/users/update/<int:user_id>/`;
export const CREATE_USER_URL = `${API_BASE_URL}/api/tracking/create-student-data/`;

export const CREATE_ATTENDANCE_URL = `${API_BASE_URL}/api/attendance/<int:user_id>/`;
export const EDIT_ATTENDANCE_URL = `${API_BASE_URL}/api/attendance/<int:user_id>/<int:id>/`;

export const VIEW_ATTENDANCE_URL = `${API_BASE_URL}/api/classes/<int:year>/<int:month>/`;
export const ATTENDANCE_DETAILS_URL= `${API_BASE_URL}/api/attendance/<str:class_name>/<str:date>/`;

export const ALUMNOSLIST_URL = `${API_BASE_URL}/api/tracking/alumnos/`;
export const PAGOS_ALUMNOS_URL = `${API_BASE_URL}/api/tracking/pagos/`;
export const MOVIMIENTOS_URL =  `${API_BASE_URL}/api/alumnos/<int:alumno_id>/movimientos/`;

export const PERIODOS_ACCESO_URL = `${API_BASE_URL}/api/periodos-acceso/`;
export const PERIODO_ACCESO_DETAIL_URL = `${API_BASE_URL}/api/periodos-acceso/<int:pk>/`;

export const CREAR_REEMBOLSOS_URL =  `${API_BASE_URL}/api/pago/<int:pago_id>/reembolso/nuevo/`;
export const ACTUALIZAR_REEMBOLSOS_URL =  `${API_BASE_URL}/api/reembolso/<int:pk>/editar/`;
export const ELIMINAR_REEMBOLSOS_URL =  `${API_BASE_URL}/api/reembolso/<int:pk>/eliminar/`;

export const CREATE_USER_AUTO_URL = `${API_BASE_URL}/api/create-user-from-alumno/`;

export const OBSERVACIONES_URL = `${API_BASE_URL}/api/users/<int:user_id>/observaciones/`;